module.exports = {

  ActionTypes: {
    CONVERSATIONS_LOAD: 'CONVERSATIONS_LOAD',
    CONVERSATIONS_LOAD_SUCCESS: 'CONVERSATIONS_LOAD_SUCCESS',
    CONVERSATIONS_LOAD_FAIL: 'CONVERSATIONS_LOAD_FAIL',
    CONVERSATION_CLICK: 'CONVERSATION_CLICK',
    CONVERSATION_ACTIVE: 'CONVERSATION_ACTIVE',

    CONVERSATION_DELETE: 'CONVERSATION_DELETE',
    CONVERSATIONS_DELETE: 'CONVERSATIONS_DELETE',

    MESSAGES_LOAD: 'MESSAGES_LOAD',
    MESSAGES_LOAD_SUCCESS: 'MESSAGES_LOAD_SUCCESS',
    MESSAGES_LOAD_FAIL: 'MESSAGES_LOAD_FAIL',

    MESSAGE_CREATE: 'MESSAGE_CREATE',
    MESSAGE_DELETE: 'MESSAGE_DELETE',

    MEMBERS_LOAD: 'MEMBERS_LOAD',
    MEMBERS_LOAD_SUCCESS: 'MEMBERS_LOAD_SUCCESS',
    MEMBERS_FETCH_SUCCESS: 'MEMBERS_FETCH_SUCCESS',
    MEMBERS_FETCH_FAIL: 'MEMBERS_FETCH_FAIL',
    MEMBERS_LOAD_FAIL: 'MEMBERS_LOAD_FAIL',
    MEMBERS_FETCH_LOADED_PAGE: 'MEMBERS_FETCH_LOADED_PAGE',
    MEMBERS_FETCH_NEXT_PAGE_SUCCESS: 'MEMBERS_FETCH_NEXT_PAGE_SUCCESS',
    MEMBER_BLOCK: 'MEMBER_BLOCK',
    MEMBER_UNBLOCK: 'MEMBER_UNBLOCK',
    MEMBER_IGNORE: 'MEMBER_IGNORE',
    MEMBER_UNIGNORE: 'MEMBER_UNIGNORE',
    SUBMIT_ON_ENTER: 'SUBMIT_ON_ENTER',

    EMOTICONS_LOAD: 'EMOTICONS_LOAD',
    EMOTICONS_LOAD_SUCCESS: 'EMOTICONS_LOAD_SUCCESS',
    EMOTICONS_LOAD_FAIL: 'EMOTICONS_LOAD_FAIL',

    GALLERY_LOAD: 'GALLERY_LOAD',
    GALLERY_LOAD_SUCCESS: 'GALLERY_LOAD_SUCCESS',
    GALLERY_LOAD_FAIL: 'GALLERY_LOAD_FAIL',
    GALLERY_LOAD_NAVIGATION: 'GALLERY_LOAD_NAVIGATION',
    GALLERY_LOAD_STATUS: 'GALLERY_LOAD_STATUS',
    GALLERY_LIKE_SUCCESS: 'GALLERY_LIKE_SUCCESS',
    GALLERY_LIKE_FAIL: 'GALLERY_LIKE_FAIL',
    GALLERY_REPORT_SUCCESS: 'GALLERY_REPORT_SUCCESS',
    GALLERY_REPORT_FAIL: 'GALLERY_REPORT_FAIL',
    GALLERY_COMPLIMENT_SEND: 'GALLERY_COMPLIMENT_SEND', // sūta
    GALLERY_COMPLIMENT_SUCCESS: 'GALLERY_COMPLIMENT_SUCCESS', // veiksmīgi
    GALLERY_COMPLIMENT_FAIL: 'GALLERY_COMPLIMENT_FAIL',

    QUESTION_LOAD: 'QUESTION_LOAD',
    QUESTION_LOAD_SUCCESS: 'QUESTION_LOAD_SUCCESS',
    QUESTION_LOAD_FAIL: 'QUESTION_LOAD_FAIL',
    QUESTION_SKIP: 'QUESTION_SKIP',
    QUESTION_SKIP_SUCCESS: 'QUESTION_SKIP_SUCCESS',
    QUESTION_SKIP_FAIL: 'QUESTION_SKIP_FAIL',
    ANSWER_SAVE: 'ANSWER_SAVE',
    ANSWER_SAVE_SUCCESS: 'ANSWER_SAVE_SUCCESS',
    ANSWER_SAVE_FAIL: 'ANSWER_SAVE_SUCCESS',

    SEARCHED_MEMBERS_LOAD: 'SEARCHED_MEMBERS_LOAD',
    SEARCHED_MEMBERS_LOAD_SUCCESS: 'SEARCHED_MEMBERS_LOAD_SUCCESS',
    SEARCHED_MEMBERS_LOAD_FAIL: 'SEARCHED_MEMBERS_LOAD_FAIL',

    QUIZ_LOAD_SUCCESS: 'QUIZ_LOAD_SUCCESS',
    QUIZ_ANSWER_SAVE: 'QUIZ_ANSWER_SAVE',
    QUIZ_RESULTS_SAVE: 'QUIZ_RESULTS_SAVE',
    QUIZ_RESULTS_SAVE_FAIL: 'QUIZ_RESULTS_SAVE_FAIL',

    SUGGESTIONS_EXTENDED_FORM_SUBMIT_SUCCESS: 'SUGGESTIONS_EXTENDED_FORM_SUBMIT_SUCCESS',
    SUGGESTIONS_EXTENDED_FORM_SUBMIT_ERROR: 'SUGGESTIONS_EXTENDED_FORM_SUBMIT_ERROR',

    DAILY_POLL_LOAD_SUCCESS: 'DAILY_POLL_LOAD_SUCCESS',
    DAILY_POLL_SUBMIT_SUCCESS: 'DAILY_POLL_SUBMIT_SUCCESS',
    DAILY_POLL_SUBMIT_ERROR: 'DAILY_POLL_SUBMIT_ERROR',

    VERIFICATION_IMAGE_SUBMIT_SUCCESS: 'VERIFICATION_IMAGE_SUBMIT_SUCCESS',
    VERIFICATION_IMAGE_SUBMIT_ERROR: 'VERIFICATION_IMAGE_SUBMIT_ERROR',

    DELETE_ME_DATA_LOAD_SUCCESS: 'DELETE_ME_DATA_LOAD_SUCCESS',
  },

  Params: {
    conversationsPage: 20, // cik sarakstes ielasa vienā reizē
    messagesPage: 15, // cik vēstules ielasa vienā reizē
  },

};
